/* eslint-disable */
window.__publicpath__ = window.serverContext && window.serverContext.PublicPath ?
  window.serverContext.PublicPath : __webpack_public_path__;
__webpack_public_path__ = window.__publicpath__;

// Fix: The webpack 4 L10n plugin's requireEnsure hook re-wraps __webpack_require__.u
// on every chunk load when running under webpack 5 compat mode, causing infinite
// recursion. Patch __webpack_require__.f.compat to only execute once.
if (typeof __webpack_require__ !== 'undefined' && __webpack_require__.f && __webpack_require__.f.compat) {
  var _origCompat = __webpack_require__.f.compat;
  var _compatDone = false;
  __webpack_require__.f.compat = function(chunkId, promises) {
    if (!_compatDone) {
      _compatDone = true;
      _origCompat(chunkId, promises);
    }
  };
}
